import { IconDashboard } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import { useViewInstances } from '#core/hooks/fusion/useViewInstances.ts';

import { AtlasAssistant, Chat, Tool } from '#plugin-chat';
import { views as viewsObject } from '#views.ts';

const views = [...Object.values(viewsObject)];

import classes from './index.module.css';
import { IpsoDomain } from '#instructions/IpsoDomain.tsx';
import { Instructions } from '#plugin-chat/lib/instructions/Instructions.tsx';

export const Route = createFileRoute('/dashboard/')({
  component: RouteComponent,
  staticData: {
    route: {
      icon: IconDashboard,
      sidebarPosition: 1,
      title: 'Placeholder Dashboard',
    },
  },
});

function RouteComponent() {
  return (
    <div className={classes.content}>
      {/* AiPSO Placeholder Dashboard */}
      <div className={classes.chat}>
        <Chat>
          <AtlasAssistant>
            <Tool.Plan />
            <Tool.DescribeViews views={views} />
            <Tool.QueryKnowledgeGraph views={views} />
            <Tool.TransformDataset />
            <Tool.JoinDatasets />
            <Tool.AskUserQuestion />
            <Tool.ShowDashboard />

            <IpsoDomain />
            <EntityOverviewInstructions />
          </AtlasAssistant>
        </Chat>
      </div>
    </div>
  );
}

function EntityOverviewInstructions() {
  const { data: instances } = useViewInstances(viewsObject.EntityAgentView, {
    filter: [
      {
        in: {
          property: viewsObject.EntityAgentView?.property.entityType,
          values: [
            // 'location',
            // 'sector',
            // 'reservoir',
            'field',
          ],
        },
      },
    ],
    limit: 1000,
  });
  const instancesByType = Object.groupBy(instances ?? [], (it) => it?.entityType ?? 'unknown');
  return (
    <Instructions priority={100}>
      {Object.entries(instancesByType).map(([entityType, instances]) => (
        <React.Fragment key={entityType}>
          <h1>`{entityType}` Entities</h1>
          <dl>
            {instances?.map(({ space, externalId, name }) => (
              <React.Fragment key={`${space}-${externalId}-${name}`}>
                <dt>{name}</dt>
                <dd>
                  {externalId} ({space})
                </dd>
              </React.Fragment>
            ))}
          </dl>
        </React.Fragment>
      ))}
    </Instructions>
  );
}
